// @flow

import { observer } from "mobx-react";
import React from "react";
import ResizeObserver from 'react-resize-observer';
import WaveSurfer from "wavesurfer.js";

import "./HtmlAudio.scss";

type Props = {
    src: string,
    autoplay: boolean,
    onPlay: ?Function,
    onEnded: ?Function
};

@observer
export default class HtmlVideo extends React.Component<Props> {
    containerRef: ?HTMLElement;
    audioElementRef: ?HTMLAudioElement;
    waveSurfer: ?WaveSurfer;

    setAudioElementRef = (audioElementRef: ?HTMLAudioElement) => {
        if(this.audioElementRef) {
            this.audioElementRef.removeEventListener('play', this.handleOnPlay);
            this.audioElementRef.removeEventListener('ended', this.handleOnEnded);
        }

        this.audioElementRef = audioElementRef;
        if(this.audioElementRef) {
            this.audioElementRef.addEventListener('play', this.handleOnPlay);
            this.audioElementRef.addEventListener('ended', this.handleOnEnded);
        }

        this.tryInitWaveSurfer();
    };

    handleOnPlay = () => {
        if(this.props.onPlay) {
            this.props.onPlay();
        }
    }

    handleOnEnded = () => {
        if(this.props.onEnded) {
            this.props.onEnded();
        }
    }

    handleResize = () => {
        if (this.waveSurfer && this.waveSurfer.drawer) {
            this.waveSurfer._onResize();
        }
    }

    setContainerRef = (containerRef: ?HTMLElement) => {
        if (!containerRef) {
            return;
        }
        this.containerRef = containerRef;
        this.tryInitWaveSurfer();
    };

    componentDidMount = () => {
        this.tryInitWaveSurfer();
    };

    tryInitWaveSurfer = () => {
        if (!this.waveSurfer && this.containerRef && this.audioElementRef) {
            this.waveSurfer = WaveSurfer.create({
                container: this.containerRef,
                backend: "MediaElement",
                responsive: true,
                mediaControls: true,
                hideScrollbar: true,
                normalize: true
            });
            this.waveSurfer.load(this.audioElementRef);
            if (this.props.autoplay) {
                this.audioElementRef.play();
            }
        }
    };

    componentWillUnmount = () => {
        if (this.waveSurfer) {
            this.waveSurfer.destroy();
            this.waveSurfer = null;
        }
        if(this.audioElementRef) {
            this.audioElementRef.removeEventListener('play', this.handleOnPlay);
            this.audioElementRef.removeEventListener('ended', this.handleOnEnded);
        }
    };

    render() {
        return (
            <div className="HtmlAudio">
                <ResizeObserver onResize={this.handleResize} />
                <div className="HtmlAudio__Icon" />
                <div
                    className="HtmlAudio__Waveform"
                    ref={this.setContainerRef}
                />
                <audio
                    src={this.props.src}
                    ref={this.setAudioElementRef}
                    controls={true}
                />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/HtmlAudio/HtmlAudio.js